import React, { useEffect, useState, useCallback } from "react";
import AllJobs from "./Job/AllJobs";
import DraftJobs from "./Job/DraftJobs";
import AddNewJobPost from "./Job/AddNewJobPost";
import JobBoards from "./Job/JobBoards";
import { NewTab, PageTabAdv } from "../../../components";
import { useModuleAccess } from "../../../hooks";
import MyJobsNew from "./Job/MyJobsNew";
import AiRecruiterJobs from "./Job/AiRecruiterJobs";
import { useSelector } from "react-redux";
import { fetchAllRecruitersAndBDMUsers, fetchAllJobsApi } from "../../../redux/slices/bdmjobs/bdmjobsApi";

const Jobs = () => {
  const [isAiTabDisabled, setIsAiTabDisabled] = useState(false);
  const { user } = useSelector((state) => state?.auth);

  const checkAiJobs = useCallback(() => {
    if (user?.data?.role?.type === 1) return setIsAiTabDisabled(false);

    const orgId = user?.data?.organizationId?.uiid;
    if (!orgId) return;

    fetchAllRecruitersAndBDMUsers({ orgId, lim: 500, ret: "uiid", fil: JSON.stringify({
          userType: { type: "NONE", value: 2 },
          status: { type: "NONE", value: 1 },
          botAssignedTo: { type: "IN", value: [user?.data?.uiid] }
        }) })
      .then(res => {
        const bots = res?.data?.data || [];
        if (!bots.length) return setIsAiTabDisabled(true);

        fetchAllJobsApi({ 
          coll: "JobPosting", lim: 1, pg: 1, 
          fil: { "aiRecruiter.isAiRecruiter": { type: "NONE", value: true }, notifyTo: { type: "IN", value: bots.map(b => b.uiid) } } 
        }).then(jobsRes => setIsAiTabDisabled(!jobsRes?.data?.data?.length));
      }).catch(err => console.error("Failed to check AI Jobs", err));
  }, [user]);

  useEffect(() => {
    checkAiJobs();
    window.addEventListener('recheckAiJobs', checkAiJobs);
    return () => window.removeEventListener('recheckAiJobs', checkAiJobs);
  }, [checkAiJobs]);

  const JobMenus = [
    {
      title: "All Jobs",
      page: <AllJobs />,
      type: "main",
      id: "jobs_alljobs",
    },
    {
      title: "My Jobs",
      page: <MyJobsNew />,
      type: "main",
      id: "jobs_myjobs",
    },
    {
      title: "Draft Jobs",
      page: <DraftJobs />,
      type: "main",
      id: "jobs_draftjobs",
    },
    {
      title: "Add New Job Post",
      page: <AddNewJobPost />,
      type: "main",
      id: "jobs_addnewjobpost",
    },
    {
      title: "Job Boards",
      page: <JobBoards />,
      type: "main",
      id: "jobs_jobboards",
    },
    {
      title: "AI Recruiter Jobs",
      page: <AiRecruiterJobs />,
      type: "main",
      disabled: isAiTabDisabled,
      id: "jobs_airecruiterjobs",
    },
  ];
  const filteredTabs = useModuleAccess({ allTabs: JobMenus, parentId: "jobs" });
  return (
    <NewTab
      tabs={filteredTabs}
      color="black"
      variant="outlined"
      mode="url"
      tabId="jobs"
    />
  );
};

export default Jobs;
